import axios from 'axios';

// API URLを動的に取得
const getApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_URL && !import.meta.env.VITE_API_URL.includes('localhost')) {
    return import.meta.env.VITE_API_URL;
  }
  
  const currentHost = window.location.host;
  const protocol = window.location.protocol;
  
  if (currentHost === 'evaloid.com') {
    return `${protocol}//${currentHost}`;
  } else if (currentHost.includes('localhost') || currentHost.includes('127.0.0.1')) {
    return 'http://localhost:8080';
  } else {
    return `https://${currentHost}`;
  }
};

const API_BASE_URL = getApiBaseUrl();

export const billingApi = {
  // Get available subscription plans
  getPlans: async () => {
    const response = await axios.get(`${API_BASE_URL}/api/billing/plans`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get current user subscription status
  getUserSubscription: async () => {
    const response = await axios.get(`${API_BASE_URL}/api/billing/subscription`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create Stripe checkout session
  createCheckoutSession: async (planId: number) => {
    const response = await axios.post(
      `${API_BASE_URL}/api/billing/create-checkout-session`,
      { plan_id: planId },
      { withCredentials: true }
    );
    return response.data;
  },

  // Cancel subscription
  cancelSubscription: async () => {
    const response = await axios.post(
      `${API_BASE_URL}/api/billing/cancel-subscription`,
      {},
      { withCredentials: true }
    );
    return response.data;
  },

  // Check if user has feature access
  hasFeatureAccess: async (feature: string): Promise<boolean> => {
    try {
      const subscription = await billingApi.getUserSubscription();
      return subscription.features && subscription.features.includes(feature);
    } catch (error) {
      console.error('Failed to check feature access:', error);
      return false;
    }
  },

  // Admin: Create developer bypass
  createDeveloperBypass: async (userId: number, reason: string, expiresAt?: string) => {
    const response = await axios.post(
      `${API_BASE_URL}/api/billing/developer-bypass`,
      { 
        user_id: userId, 
        reason,
        ...(expiresAt && { expires_at: expiresAt })
      },
      { withCredentials: true }
    );
    return response.data;
  }
};